// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./vuex/store.js";
import $ from "jquery";
import 'babel-polyfill';
import { Swipe, SwipeItem } from 'vant';
var url = location.href;
let flag = navigator.userAgent.match(
    /(phone|pad|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows phone)/i
);
if (url.indexOf("/mobile/") > 0) {
    if (!flag) {//非移动端
        url = url.replace("/mobile", "");
        location.href = url;
    }
} else {
    if (flag) {//移动端
        const parsedUrl = new URL(url);        
        url = url.replace(parsedUrl.origin, parsedUrl.origin + "/#/mobile");
        location.href = url;
    }
}

Vue.use(Swipe);
Vue.use(SwipeItem);
/* eslint-disable no-new */
new Vue({
    el: "#app",
    router,
    store,
    $,
    template: "<App/>",
    components: { App }
});
//清空查询数据
Vue.prototype.clearObject = function (object) {
    for (let key in object) {
        object[key] = "";
    }

};


//权限检查方法
Vue.prototype.getNickName = function (value) {
    let user = localStorage.getItem('access-user');
    if (user) {
        user = JSON.parse(user);
        if (user.userAccount) {
            return user.userAccount;
        }
    }
    return "";
};

Vue.prototype.checkLogin = function (value) {
    let user = localStorage.getItem('access-user');
    if (user) {
      user = JSON.parse(user);
      if (user.userAccount) {
        return true;
      } else {
        return false;
      }
    } else {
        return false;
    }    
    return false;
};


// WEBPACK FOOTER //
// ./src/main.js